<script lang="ts" setup>
import { initWebSocket } from "@/pinia/stores/workScoket"
// import { usePany } from "@@/composables/usePany"
import { useTheme } from "@@/composables/useTheme"
import en from "element-plus/es/locale/lang/en"
import zhCn from "element-plus/es/locale/lang/zh-cn" // Element Plus 中文包
import { useI18n } from "vue-i18n"
import { getToken } from "./common/utils/cache/cookies"

const i18n = useI18n()
const { initTheme } = useTheme()
// const { initGreyAndColorWeakness } = useGreyAndColorWeakness()
// const { initStarNotification, initStoreNotification } = usePany()

// 初始化主题
initTheme()
// 初始化灰色模式和色弱模式
// initGreyAndColorWeakness()
// 初始化通知
// initStarNotification()
// initStoreNotification()

if (import.meta.env.VITE_WS_ENABLE === "true" && location.hash !== "#/login" && getToken()) {
  initWebSocket()
}
const elLocale = computed(() => (i18n.locale.value === "zhCn" ? zhCn : en))
</script>

<template>
  <el-config-provider :locale="elLocale">
    <router-view />
  </el-config-provider>
</template>
